import { mapEnumToOptions } from '@abp/ng.core';

export enum D365DocumentType {
  CustomerInvoice = 0,
  CreditNote = 1,
  VendorInvoice = 2,
  VendorInvoiceR = 3,
  VendorAccrual = 4,
  CustomerAccrual = 5,
}

export const d365DocumentTypeOptions = mapEnumToOptions(D365DocumentType);
